import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[70vh] w-full flex-col items-center justify-center px-4 py-20 text-center">
      <span className="font-heading text-7xl font-800 text-primary-500 md:text-9xl">
        404
      </span>
      <h1 className="mt-6 font-heading text-xl font-700 text-foreground-50 md:text-2xl">
        抱歉，这个页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-400">
        你访问的路径
        <span className="mx-1 rounded bg-background-800 px-2 py-0.5 font-mono text-xs text-secondary-300">
          {location.pathname}
        </span>
        不存在或已被移除，不如去看看精彩影视内容。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-700 text-background-950 transition-colors hover:bg-accent-600"
        >
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-600 px-6 py-2.5 text-sm font-600 text-foreground-200 transition-colors hover:border-secondary-500 hover:text-secondary-300"
        >
          浏览全部影视
        </Link>
      </div>
    </div>
  );
}